var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Appear extends Component {
    constructor(isDebugEnabled = false) {
        super('Appear', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $(window).on('scroll', this.inScreen);
            setTimeout(() => {
                this.inScreen();
            }, 250);
            this.success();
        });
    }
    inScreen() {
        const padding = $(window).width() < 768 ? 25 : 75;
        let timeout = 0;
        let index = 0;
        $('.appear-image, .appear-block').each((element) => {
            if (element.viewportPosition().y < $(window).height() - 75 && !element.hasClass('is-appearing') && !element.hasClass('in-screen')) {
                element.addClass('is-appearing');
                setTimeout(() => {
                    element.addClass('in-screen');
                }, timeout + index * 40);
                index++;
            }
        });
    }
}
